/**
 * @author Ariel
 * @description 岗位分类管理
 * @Date 2019/12/31
 */
import React from "react";
import {connect} from "dva";
import {templateConfig,reduxTemplateConfig} from "./config";

import {framework_tool} from '../../../tool';
let {WizContainer, WizReduxTemplate} = framework_tool;

class PositionCategoryManager extends WizContainer {
  componentName = 'positionCategoryManager';

  constructor(props){
    super(props);
    this.state = {
    }
  };

  _handleCMD(nextProps, nextState, key){
    let o = nextProps[key];
    if (o['success']) {
      wizNotice.success(o['msg']);
      return true;
    } else {
      wizNotice.error(o['msg']);
      return false;
    }
  }

  _render() {
    let _reduxTemplateConfig = reduxTemplateConfig({
      templateConfig,
      apiDataFormat: {
        add: this._handleCMD,
        update: this._handleCMD,
        delete: this._handleCMD,
      },
    })
    return <WizReduxTemplate {..._reduxTemplateConfig}/>
  }
};

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(PositionCategoryManager);
